import { render, staticRenderFns } from "./OpinionOrAdvice.vue?vue&type=template&id=5daaa852&scoped=true&"
import script from "./OpinionOrAdvice.vue?vue&type=script&lang=js&"
export * from "./OpinionOrAdvice.vue?vue&type=script&lang=js&"
import style0 from "./OpinionOrAdvice.vue?vue&type=style&index=0&id=5daaa852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daaa852",
  null
  
)

export default component.exports